import { Users } from "lucide-react";
import { getFamiliesWithLastVisit } from "@/lib/api";

// getFamilies(churchId) is church-scoped; for district-wide search we need
// getFamiliesWithLastVisit which queries by district_id.
const familiesProvider = {
  id: "familias",
  label: "Familias",
  icon: Users,
  iconBg: "bg-indigo-50",
  iconColor: "text-indigo-600",
  fields: ["name", "address"],
  load: (districtId) => getFamiliesWithLastVisit(districtId),
  buildItem: (f) => ({
    id: f.id,
    title: f.name,
    subtitle: f.address || "Familia",
    route: `/families/${f.id}`,
    recent: { id: f.id, type: "family", title: f.name, subtitle: f.address || "Familia", route: `/families/${f.id}` },
  }),
};

export default familiesProvider;
